module.exports = __webpack_public_path__ + "media/images/icons/rooms/sink-ef4e5cd37f6069fa58e14488cf4fcd36.svg";